<script>
    import { isMobile } from "../../../stores";

    import { pageOptions } from "../../../Utils/utilEnums.svelte";

    import { getNumberWithComma } from "../../../Utils/utilFunctions.svelte";

    import ExportTableDataDropdown from "../../Common/ExportTableDataDropdown.svelte";

    import { Pagination } from "../../Common/index.svelte";

    export let onPageChange = () => {};
    export let onPageSizeChange = () => {};
    export let showSelected = false;
    export let selectedCount = 0;
    export let tableData = [];

    export let page = Number(0);
    export let pageSize = Number(25);
    export let count = Number(0);

    export let csvConfig = {};
</script>

<div class="flex flex-col">
    <div class="flex flex-1 justify-between items-center">
        <div class="flex flex-row items-center gay-x-4">
            <div
                class="flex items-center {$isMobile ? 'flex-col' : 'flex-row'}"
            >
                <strong class="text-gray-600 text-sm">Table size:</strong>
                <select
                    class="select select-sm text-gray-600 {$isMobile
                        ? 'm-2'
                        : 'mx-2'}"
                    bind:value={pageSize}
                    on:change|preventDefault={() => {
                        onPageSizeChange(pageSize);
                    }}
                >
                    {#each pageOptions as pageOption}
                        <option
                            value={pageOption.amount}
                            selected={pageOption.amount === pageSize}
                        >
                            {pageOption.amount}
                        </option>
                    {/each}
                </select>
            </div>

            <div class="flex flex-row items-center gap-x-6">
                {#if $isMobile}
                    <strong class="text-gray-600 text-sm flex flex-col">
                        Total:
                        <span class="text-gray-600 h-4 my-4 align-middle">
                            {getNumberWithComma(count)}
                        </span>
                    </strong>

                    {#if showSelected}
                        <strong class="text-gray-600 text-sm flex flex-col">
                            Selected:
                            <span class="text-gray-600 h-4 my-4 align-middle">
                                {getNumberWithComma(selectedCount)}
                            </span>
                        </strong>
                    {/if}
                {:else}
                    <strong class="text-gray-600 text-sm">
                        Total records:
                        <span class="text-gray-600">
                            {getNumberWithComma(count)}
                        </span>
                    </strong>

                    {#if showSelected}
                        <strong class="text-gray-600 text-sm">
                            Selected:
                            <span class="text-gray-600 h-4 my-4 align-middle">
                                {getNumberWithComma(selectedCount)}
                            </span>
                        </strong>
                    {/if}
                {/if}

                <ExportTableDataDropdown {csvConfig} />
            </div>
        </div>

        {#if tableData.length}
            <Pagination
                {page}
                {pageSize}
                {count}
                on:onPageChange={onPageChange}
            />
        {/if}
    </div>
</div>
